import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers";
import { MerchantActions } from "./merchant.actions"
import { Merchant, AccountModel, BookingOffice } from "../../models";

@Injectable()
export class MerchantResolver implements Resolve<void> {

	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const merchantId = route.params["id"]
		return this.store.dispatch(this.merchantActions.loadMerchantByMerchantId(merchantId))
	}
}

@Injectable()
export class AccountListResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const merchantId = route.parent.params["id"]
		return this.store.dispatch(this.merchantActions.loadMerchantAccounts(merchantId))
	}
}

@Injectable()
export class AccountCreateResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	){}
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		return this.store.dispatch(this.merchantActions.merchantAccountLoaded(null))
	}
}

@Injectable()
export class AccountEditResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	){}
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const accountId = route.params["id"];
		return this.store.dispatch(this.merchantActions.loadMerchantAccountById(accountId))
	}
}

@Injectable()
export class BookingOfficeResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	) { }
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		return this.store.select("merchantState", "merchant")
			.filter(merchant => merchant != null || merchant != undefined)
			.take(1)
			.subscribe(merchant => this.store.dispatch(this.merchantActions.loadBookingOffices(merchant._links.bookingOffices.href)))
	}
}

@Injectable()
export class EmailConfigListResolver implements Resolve<void> {
	constructor(
		private store: Store<AppState>,
		private merchantActions: MerchantActions
	) {}
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		const merchantId = route.parent.params["id"]
		return this.store.dispatch(this.merchantActions.loadMerchantEmailConfigs(merchantId));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/merchants/merchant.resolver.ts